module.exports = __webpack_public_path__ + "img/icon90.9c9d3e1e.png";